import ReactMarkdown from 'react-markdown'
import React from 'react'

export const Markdown = (props) => {
    // Possible types in the future:
    // blockquote, image, break, table
    // List bug: https://github.com/remarkjs/react-markdown/issues/38#issuecomment-581323644

    const allowedTypes = [
        'root',
        'text',
        'emphasis',
        'strong',
        'delete',
        'link',
        'heading',
        'inlineCode',
        'code',
        'list'
    ]

    return (
        <ReactMarkdown
            unwrapDisallowed
            allowedTypes={allowedTypes}
            renderers={{ list: () => props.children }}
            {...props}
        />
    )
}
